

function reverseShippingCountriesJson(obj) {
  const reversed = {};
  for (const [key, value] of Object.entries(obj)) {
    if (value && value.country) {
      // Include country code inside the reversed object for full access
      reversed[value.country] = Object.freeze({
        code: key,
        admin_fee_without_vat: value.admin_fee_without_vat,
        vat: value.vat,
        currency: value.currency,
      });
    }
  }
  return Object.freeze(reversed);
}

// ✅ Make globally available
window.reverseShippingCountriesJson = reverseShippingCountriesJson;
